var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCotiza(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cotiza",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.746,
    height: 45.745,
    viewBox: "0 0 45.746 45.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #003169;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-1",
    d: "M643.873,494a22.872,22.872,0,1,0,22.873,22.872A22.872,22.872,0,0,0,643.873,494Zm1.385,33.06v2.649a.708.708,0,0,1-.734.714H642.76a.717.717,0,0,1-.748-.714v-2.416a15.145,15.145,0,0,1-4.506-.888,1.417,1.417,0,0,1-.866-1.672l.287-1.124a1.415,1.415,0,0,1,1.88-.967,11.368,11.368,0,0,0,4.069.793c1.9,0,3.193-.734,3.193-2.065,0-1.269-1.064-2.066-3.529-2.9-3.562-1.2-6-2.863-6-6.1,0-2.93,2.075-5.225,5.619-5.925v-2.415a.8.8,0,0,1,.768-.783h1.764a.75.75,0,0,1,.714.783v2.182a13.174,13.174,0,0,1,3.607.6,1.424,1.424,0,0,1,.943,1.7l-.254,1a1.427,1.427,0,0,1-.7.895,1.385,1.385,0,0,1-1.127.092,10.227,10.227,0,0,0-3.368-.554c-2.164,0-2.863.933-2.863,1.866,0,1.1,1.166,1.8,4,2.863,3.96,1.4,5.556,3.228,5.556,6.226,0,2.965-2.1,5.492-5.935,6.158Zm0,0",
    transform: "translate(-621 -494)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCotiza);
export default __webpack_public_path__ + "static/media/cotiza.a09a1fefbd7a790579ace654fe925cd9.svg";
export { ForwardRef as ReactComponent };